import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建DSP管理员
export const CREATE_ACCOUNT_DSP_MANAGER = gql`
    mutation CreateAccountDspManager($input: AccountDspManagerInput!) {
        createAccountDspManager(input: $input)
    }
`;

// 更新DSP管理员
export const UPDATE_ACCOUNT_DSP_MANAGER = gql`
    mutation UpdateAccountDspManager($input: AccountDspManagerInput!) {
        updateAccountDspManager(input: $input)
    }
`;


export interface AccountDspManagerInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    dspId: number;
    role: string;
}

export const createAccountDspManager = async (input: AccountDspManagerInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_DSP_MANAGER,
        variables: {input}
    });
    return data.createAccountDspManager;
};

export const updateAccountDspManager = async (input: AccountDspManagerInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_DSP_MANAGER,
        variables: {input}
    });
    return data.updateAccountDspManager;
};